package com.example.borshi.web.data

import com.example.borshi.web.cart.CartLineItem

/**
 * Shared web order models (align roughly with Android Order data class)
 */
data class WebOrderItem(
    val productId: String = "",
    val name: String = "",
    val quantity: Int = 0,
    val price: Double = 0.0,
    val type: OrderItemType = OrderItemType.ONE_TIME,
    val packSize: String? = null,
    val weight: String? = null,
    val scheduleSummary: String? = null,
    val imageUrl: String? = null
)

data class WebOrder(
    val id: String,
    val userId: String,
    val customerName: String,
    val customerPhone: String,
    val deliveryAddress: String,
    val status: String,
    val paymentStatus: String = "",
    val paymentMethod: String,
    val cashfreeOrderId: String = "",
    val totalAmount: Double,
    val payTodayAmount: Double,
    val createdAt: Long,
    val updatedAt: Long = 0L,
    val paidAt: Long = 0L,
    val items: List<WebOrderItem>
)

enum class OrderItemType { ONE_TIME, SUBSCRIPTION }

fun CartLineItem.Subscription.toOrderItem(): WebOrderItem = WebOrderItem(
    productId = productId,
    name = name,
    quantity = quantityPerDelivery,
    price = price,
    type = OrderItemType.SUBSCRIPTION,
    packSize = packSize,
    scheduleSummary = schedule.toSummaryString(),
    imageUrl = imageUrl
)

fun CartLineItem.OneTime.toOrderItem(): WebOrderItem = WebOrderItem(
    productId = productId,
    name = name,
    quantity = quantity,
    price = price,
    type = OrderItemType.ONE_TIME,
    weight = weight,
    imageUrl = imageUrl
)
